// ===== MEDICINE & AYUSH =====
const MEDICAL = [
  {
    id: "mbbs",
    name: "MBBS (Bachelor of Medicine & Bachelor of Surgery)",
    stream: "science",
    category: "medical",
    summary:
      "Allopathic medical course: diagnosis, treatment, surgery, and patient care.",
    eligibility:
      "10+2 with PCB; NEET UG compulsory; age 17+ years at admission.",
    exams: ["NEET UG"],
    colleges: [
      "AIIMS New Delhi",
      "Maulana Azad Medical College, Delhi",
      "Christian Medical College, Vellore",
      "King George's Medical University, Lucknow",
      "Grant Medical College, Mumbai",
      "JIPMER Puducherry",
      "Lady Hardinge Medical College, Delhi"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["medicine", "surgery", "healthcare", "patient care"],
  },
  {
    id: "bds",
    name: "BDS (Bachelor of Dental Surgery)",
    stream: "science",
    category: "medical",
    summary:
      "Dentistry course: oral health, orthodontics, periodontics, oral pathology & surgery.",
    eligibility: "10+2 with PCB; NEET UG compulsory.",
    exams: ["NEET UG"],
    colleges: [
      "Maulana Azad Dental College, Delhi",
      "Faculty of Dental Sciences, BHU Varanasi",
      "Government Dental College, Mumbai",
      "KLE Institute of Dental Sciences, Belgaum",
      "Dr. R. Ahmed Dental College, Kolkata"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["dentistry", "oral health", "orthodontics", "surgery"],
  },
  {
    id: "bams",
    name: "BAMS (Bachelor of Ayurvedic Medicine & Surgery)",
    stream: "science",
    category: "medical",
    summary:
      "Ayurveda: traditional Indian medicine, therapies, Panchakarma, herbal formulations.",
    eligibility: "10+2 with PCB; NEET UG mandatory for most colleges.",
    exams: ["NEET UG", "State AYUSH entrance exams"],
    colleges: [
      "National Institute of Ayurveda, Jaipur",
      "BHARATIYA AYURVEDIC COLLEGE, Pune",
      "Government Ayurvedic College, Bangalore",
      "Banaras Hindu University, Varanasi"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["Ayurveda", "herbal medicine", "therapies"],
  },
  {
    id: "bhms",
    name: "BHMS (Bachelor of Homeopathic Medicine & Surgery)",
    stream: "science",
    category: "medical",
    summary:
      "Homeopathy: alternative medicine, remedies, patient treatment & research.",
    eligibility: "10+2 with PCB; NEET UG mandatory for most colleges.",
    exams: ["NEET UG", "State AYUSH entrance exams"],
    colleges: [
      "National Institute of Homeopathy, Kolkata",
      "Calcutta Homoeopathic Medical College",
      "Delhi Homoeopathic Medical College",
      "Dr. B. R. Sur Homoeopathic College, Mumbai"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["homeopathy", "alternative medicine", "remedies"],
  },
  {
    id: "bnys",
    name: "BNYS (Bachelor of Naturopathy & Yoga Sciences)",
    stream: "science",
    category: "medical",
    summary:
      "Naturopathy & Yoga: natural therapies, wellness, physical & mental health care.",
    eligibility: "10+2 with PCB; NEET UG/State entrance exams for AYUSH may apply.",
    exams: ["NEET UG", "State AYUSH entrance exams"],
    colleges: [
      "Morarji Desai National Institute of Yoga, Delhi",
      "Dr. Bhanuben Nanavati College of Ayurveda, Mumbai",
      "National Institute of Naturopathy, Pune"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["Naturopathy", "Yoga", "wellness", "therapies"],
  },
  {
    id: "pharmacy",
    name: "B.Pharm (Bachelor of Pharmacy)",
    stream: "science",
    category: "medical",
    summary:
      "Pharmaceutical sciences: drug formulation, production, research & clinical applications.",
    eligibility: "10+2 with PCB/PCM; some institutes require NEET UG or state pharmacy entrance exams.",
    exams: ["NEET UG", "GPAT (for postgrad)", "State Pharmacy CETs", "CUET UG"],
    colleges: [
      "Jamia Hamdard, Delhi",
      "Manipal College of Pharmaceutical Sciences",
      "NIPER, Mohali (for postgraduate)",
      "Delhi Institute of Pharmaceutical Sciences & Research",
      "Bharati Vidyapeeth College of Pharmacy, Pune"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["pharmacy", "drugs", "formulation", "research"],
  },
  {
    id: "nursing",
    name: "B.Sc Nursing",
    stream: "science",
    category: "medical",
    summary:
      "Nursing: patient care, medical procedures, hospital management, and community health.",
    eligibility: "10+2 with PCB; some institutes require entrance exams (AIIMS Nursing/State Nursing CET).",
    exams: ["AIIMS Nursing", "State Nursing Entrance Exams", "CUET UG"],
    colleges: [
      "AIIMS New Delhi",
      "PGIMER Chandigarh",
      "Lady Hardinge Medical College, Delhi",
      "Christian Medical College, Vellore"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["nursing", "patient care", "hospital", "community health"],
  },
  {
    id: "physiotherapy",
    name: "BPT (Bachelor of Physiotherapy)",
    stream: "science",
    category: "medical",
    summary:
      "Physiotherapy: rehabilitation, therapy, musculoskeletal & neurological patient care.",
    eligibility: "10+2 with PCB; entrance exams vary by institute (State or CUET UG).",
    exams: ["CUET UG", "State Physiotherapy Entrance Exams"],
    colleges: [
      "All India Institute of Medical Sciences (AIIMS) Delhi",
      "Manipal College of Health Professions",
      "Christian Medical College, Vellore",
      "Jamia Millia Islamia, Delhi"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["physiotherapy", "rehabilitation", "therapy"],
  },
  {
    id: "paramedical",
    name: "B.Sc Paramedical Sciences",
    stream: "science",
    category: "medical",
    summary:
      "Diagnostic and allied medical services: lab technology, imaging, blood banking, and medical assistance.",
    eligibility: "10+2 with PCB; some colleges may have entrance tests or CUET UG.",
    exams: ["CUET UG", "State Paramedical CETs"],
    colleges: [
      "AIIMS Delhi",
      "King George's Medical University, Lucknow",
      "Manipal College of Health Professions",
      "Christian Medical College, Vellore"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["paramedical", "diagnostics", "lab technology"],
  },
];

export default MEDICAL;
